import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";

export const GoogleMapsButton = (props: { className?: string; latitude: number; longitude: number }) => (
    <a
        className={`btn btn-primary fw-semibold d-inline-flex align-items-center gap-2 ${props.className || ""}`}
        href={`https://www.google.com/maps/search/?api=1&query=${props.latitude},${props.longitude}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ borderRadius: "0.65rem", padding: "0.5rem 1rem" }}
    >
        <FontAwesomeIcon icon={faLocationArrow} size="sm" />
        <span>Directions on Google Maps</span>
    </a>
);
